import { ActivationBanner } from "../../components/ActivationBanner"
import { SettingsNavLinks } from "../../components/SettingsNavLinks"
import { Card, SwitchAppButton } from "../../components"

import cardIcon from "../../assets/icons/payment-card.svg"
import BankTransferIcon from "../../assets/icons/bank-transfer.svg"
import QrCodeIcon from "../../assets/icons/qr-code.svg"
import  UssdTransferIcon from "../../assets/icons/ussd-transfer.svg"

import paystack from "../../assets/icons/paystack.svg"
import flutterwave from "../../assets/icons/flutterwave.svg"
import stripe from "../../assets/icons/stripe.svg"
import square from "../../assets/icons/square.svg"

export const View = () =>{
 const InvoiceTemplate = ({leftInvoice,rightInvoice}:
    {leftInvoice:string,rightInvoice:string})=>{
    return(
       
            <div className="branding">
                <div className="left-branding">{leftInvoice}</div>
                <div></div>
                <div className="right-branding">{rightInvoice}</div>
            </div>

       
    )

 }

    return(

        <>
            <SettingsNavLinks
      navtitle="Settings"
      navtitlelink="Invoice Template"
      />
      <ActivationBanner 
            title="Please you need to activate your profile"
            subtitle="0ur guide will help you complete your Business profile and you’ll start receiving payments. Click this banner to complete your set-up."
            urlTarget="/onboarding"
      />
      <Card>
        <div className="invoice-template-section-header ">
            <strong >Configure invoice template</strong>
        </div>
        <div className="invoice-template-content ">
         <InvoiceTemplate
           leftInvoice="Branding" 
           rightInvoice="Change how your invoice emails, receipts, and payment page look in Branding settings"
         />
         <InvoiceTemplate
           leftInvoice="Business information" 
           rightInvoice="Change the contact information that shows up on your invoices and receipts in Business settings."
         />
        <div className="invoice-Text-area">
       <InvoiceTemplate
           leftInvoice="Default memo" 
           rightInvoice=""
         />
           <textarea name="text" id="1" ></textarea>
           <div className="description-character">
           <p>This will appear in the invoice email, PDF, and payment page.</p>
           <p>500 characters remaining</p>
           </div>
        </div>
        <div className="invoice-Text-area">
       <InvoiceTemplate
           leftInvoice="Default memo" 
           rightInvoice=""
         />
           <textarea name="text" id="1" ></textarea>
           <div className="description-character">
           <p>This will appear in the invoice email, PDF, and payment page.</p>
           <p>500 characters remaining</p>
           </div>
          
        </div>
      
        <InvoiceTemplate
           leftInvoice="Default payment terms" 
           rightInvoice="payment due"
         />
            
            <div>
            <InvoiceTemplate
           leftInvoice="Payment method Gateways" 
           rightInvoice=""
         />
           
                <p></p>
                <img src={UssdTransferIcon} alt="ussd-icon" />
                <img src={paystack} alt="ussd-icon" />
                <img src={flutterwave} alt="ussd-icon" />
                <img src={stripe} alt="ussd-icon" />
                <img src={square} alt="ussd-icon" />
                <img src={QrCodeIcon} alt="ussd-icon" />
                <img src={cardIcon} alt="ussd-icon" />
                <img src={BankTransferIcon} alt="ussd-icon" />
                <SwitchAppButton
                kind="success"
                onClick={()=>{}}
                >
                 edit
                </SwitchAppButton>
            </div>
                
                <div className="float-right">
                <SwitchAppButton
                className="switchapp-themed "
                kind="success"  onClick={ (): void =>{("")} }            
                >Cancel</SwitchAppButton>
                <SwitchAppButton
                className="switchapp-themed save-button"
                kind="primary"  onClick={ (): void =>{("")} }            
                >Save    </SwitchAppButton>
            </div>
        </div>
      </Card>
        </>
    )
}